export default __webpack_public_path__ + "static/img_we_3@2x-21447a964b23e9c780e7782f568225ff.png";